import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

interface ExportColumn {
  header: string;
  key: string;
  width?: number;
}

interface ExportOptions {
  title: string;
  columns: ExportColumn[];
  data: any[];
  filename: string;
}

export function exportToCSV(options: ExportOptions) {
  const { columns, data, filename } = options;
  
  const headers = columns.map(col => col.header).join(',');
  const rows = data.map(row => 
    columns.map(col => {
      const value = row[col.key];
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value ?? '';
    }).join(',')
  );
  
  const csv = [headers, ...rows].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${filename}.csv`);
}

export function exportToPDF(options: ExportOptions) {
  const { title, columns, data, filename } = options;
  
  const doc = new jsPDF();
  
  // Título
  doc.setFontSize(18);
  doc.text(title, 14, 22);
  
  // Data de geração
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text(`Gerado em: ${new Date().toLocaleString('pt-BR')}`, 14, 30);
  
  // Tabela
  const tableColumns = columns.map(col => ({ header: col.header, dataKey: col.key }));
  
  (doc as any).autoTable({
    columns: tableColumns,
    body: data,
    startY: 35,
    styles: {
      fontSize: 9,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [24, 144, 255],
      textColor: 255,
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    margin: { top: 35 },
  });
  
  // Rodapé
  const pageCount = (doc as any).internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(
      `Layout Remote - Página ${i} de ${pageCount}`,
      doc.internal.pageSize.width / 2,
      doc.internal.pageSize.height - 10,
      { align: 'center' }
    );
  }
  
  doc.save(`${filename}.pdf`);
}

export function formatDate(date: string | Date): string {
  if (!date) return '-';
  return new Date(date).toLocaleString('pt-BR');
}

export function formatStatus(status: string): string {
  const statusMap: Record<string, string> = {
    'ACTIVE': 'Ativo',
    'INACTIVE': 'Inativo',
    'SUSPENDED': 'Suspenso',
    'ONLINE': 'Online',
    'OFFLINE': 'Offline',
    'MAINTENANCE': 'Manutenção',
    'CONNECTED': 'Conectado',
    'PENDING': 'Pendente',
    'DISCONNECTED': 'Desconectado',
    'FAILED': 'Falhou',
    'SUPER_ADMIN': 'Super Admin',
    'ADMIN': 'Admin',
    'OPERATOR': 'Operador',
    'VIEWER': 'Visualizador',
  };
  return statusMap[status] || status;
}
